import * as React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import './global';

import './styles/main.scss';

import CollabApp from './layouts/App';

import gaProvider from 'modules/tracking/providers/gaProvider';

import { ConsentService, getConsentAsync } from 'utils/consents';

// Initialize Sentry as soon as possible in order to have the most code coverage possible
getConsentAsync(ConsentService.SENTRY)
  .then((hasConsent) => {
    if (hasConsent) {
      Sentry.init({
        dsn: 'https://32a04f8368ef4e7d9b6f3a77b4770b0d@sentry.stups.zalan.do/1894',
        release: window.SENTRY_RELEASE ? window.SENTRY_RELEASE.id : '0.0.0',
        enabled: window.app.env.NODE_ENV === 'production',
        environment: window.app.env.IS_PROD ? 'production' : 'staging'
      });
    }
  });

gaProvider.init(window.app.env.GOOGLE_ANALYTICS_4_ID);

function onUpdate(location, prevPathname) {
  const isSignupRoute = [
    '/signup/brand',
    '/signup/content-creator',
    '/signup/agency'
  ].includes(location);

  if (isSignupRoute) {
    return;
  }

  const { pathname } = location;
  const isCcmOverviewPage = /campaigns\/ccm\/\d+\/participants/.test(pathname)
    || /campaigns\/ccm\/\d+\/subcampaigns\/\d+/.test(pathname);

  if (pathname !== prevPathname && !isCcmOverviewPage) {
    window.scrollTo(0, 0);
  }
}

const container = document.getElementById('app');

if (container === null) {
  throw new Error('Container <div id="app" /> not found!!!!');
}

createRoot(container)
  .render(<CollabApp onUpdate={onUpdate} />);
